import React, { useState, useEffect } from "react";
import { ThanksScreen } from "./ThanksScreen";
import { TryAgainScreen } from "./TryAgainScreen";
import { SorryUser } from "./SorryUser";
import { PendingStart } from "./PendingStart";
import { useSearchParams } from "react-router-dom";
const apiBaseURL = process.env.REACT_APP_API_URL || `${window.location.origin}`;

const options = {
  hour: "2-digit",
  minute: "2-digit",
  hour12: true,
  day: "numeric",
  month: "long",
  year: "numeric",
};

export const QuestionAnswer = () => {
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [startDateTime, setStartDateTime] = useState();
  const [endDateTime, setEndDateTime] = useState();

  const [answers, setAnswers] = useState({});
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [questionAnswerSet, setQuestionAnswerSet] = useState([]);
  const [contestId, setContestId] = useState(null);
  const [validateMobileUser, setValidateMobileUser] = useState(0);
  const [notMatchMovile, setNotMatchMovile] = useState(false);
  const [step, setStep] = useState(0);

  const [timeLeft, setTimeLeft] = useState();
  const [searchParams] = useSearchParams();
  const paramsMoble = searchParams.get("key")?.replace(/ /g, "+");

  const setTimer = (endDateTime) => {
    const targetDate = new Date(endDateTime);
    setTimeLeft(Math.max(0, Math.floor(targetDate - Date.now()) / 1000));
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await validateMobileAndCheckCTEligibility();
      } catch (error) {
        setError("Failed to load data. Please try again later.");
      }
    };
    fetchData();
  }, []);

  const handleSelect = (optionId) => {
    setAnswers((prev) => ({ ...prev, [step]: optionId }));
    setError("");
  };

  if (submitted) {
    return <ThanksScreen />;
  }

  //Mobile number verification status API call
  const validateMobileAndCheckCTEligibility = async () => {
    let userMobile = "";
    setPageLoading(true);
    const payload = { MobileNumber: paramsMoble };
    try {
      const response = await fetch(
        `${apiBaseURL}/api/DishKiCT/ValidateMobileAndCheckCTEligibility`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      if (data.resultStatus === "Success") {
        userMobile = data?.result?.mobileNumber;
        setValidateMobileUser(data?.result?.mobileNumber);
        await getQuizScheduleDetails();
        await GetDishKiCTQuestions(data?.result?.mobileNumber);
        localStorage.setItem("mobileNumber", data.result.mobileNumber);
      } else if (data?.resultStatus === "Failed") {
        setNotMatchMovile(true);
      }
    } catch (error) {
      console.error("Error validating mobile number:", error);
    } finally {
      setPageLoading(false);
      handleGTMTaggingOnLanding("lp_view_all", "LandingPage", userMobile);
      handleGTMTaggingOnLanding("lp_view_unique", "LandingPage", userMobile);
    }
  };

  const handleGTMTaggingOnLanding = (event, pageName, userMobile) => {
    window.dataLayer.push({
      event: event,
      page_name: pageName,
      source_url: window.location.href,
      mobile_number: userMobile,
      platform: "Watcho_championstrophy",
      user_type: "vzy",
    });
  };

  // Date Timer API call
  const getQuizScheduleDetails = async () => {
    setPageLoading(true);
    try {
      const response = await fetch(
        `${apiBaseURL}/api/DishKiCT/GetQuizScheduleDetails`,
        {
          method: "GET",
        },
      );
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);
      const dateTime = await response.json();

      const quizStartTime = new Date(dateTime?.result?.quizStartTime);
      const startDateTime = quizStartTime.toLocaleString("en-US", options);
      setStartDateTime(startDateTime);
      const quizEndTime = new Date(dateTime?.result?.quizEndTime);
      const endDateTime = quizEndTime.toLocaleString("en-US", options);
      setEndDateTime(endDateTime);
      setTimer(quizEndTime);
    } catch (error) {
      console.error("Error fetching quiz schedule details:", error);
    } finally {
      setPageLoading(false);
    }
  };

  // get all Question API Call
  const GetDishKiCTQuestions = async (mobileNumber) => {
    setPageLoading(true);
    setLoading(true);
    try {
      const payload = { MobileNumber: mobileNumber };
      const response = await fetch(
        `${apiBaseURL}/api/DishKiCT/GetDishKiCTQuestions`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      if (data.resultStatus === "Success" && data.result) {
        const submittedCount = data.result.filter(
          (q) => q.isSubmitted === 1,
        ).length;
        if (data.result.length > 0) {
          setStep(submittedCount);
        } else {
          setStep(-1);
        }

        setQuestionAnswerSet(data.result);
        setContestId(data.contestId || data.result[0]?.contestId);
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
    } finally {
      setPageLoading(false);
      setLoading(false);
    }
  };

  // Save question answers API Call
  const submitDishKiCT = async (payload) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${apiBaseURL}/api/DishKiCT/SubmitDishKiCTResponse`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      if (result?.resultStatus !== "Success") {
        throw new Error(
          result?.message || "Submission failed. Please try again.",
        );
      }
      return result;
    } catch (error) {
      console.error("Error saving answer:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const nextStep = async () => {
    if (answers[step] !== undefined && questionAnswerSet.length > 0) {
      const currentQuestion = questionAnswerSet[step];
      const selectedOption = currentQuestion.options.find(
        (opt) => opt.optionId === answers[step],
      );
      if (!selectedOption) {
        setError("Selected option not found.");
        return;
      }

      const payload = {
        MobileNumber: validateMobileUser,
        ContestId: contestId || currentQuestion.contestId,
        QId: currentQuestion.qId,
        SelectedAnswer: selectedOption.optionName,
      };
      await submitDishKiCT(payload);
      if (step < questionAnswerSet.length - 1) {
        setStep(step + 1);
      } else {
        setSubmitted(true);
      }
    } else {
      setError("Please select an option before proceeding.");
    }
  };

  return (
    <div className="quiz-container">
      {pageLoading ? (
        <span className="DishKiChampionsTrophy-loader"></span>
      ) : (
        <>
          {notMatchMovile ? (
            <TryAgainScreen />
          ) : (
            <>
              {step >= 0 && step < questionAnswerSet?.length ? (
                <>
                  {loading ? (
                    <span className="DishKiChampionsTrophy-loader"></span>
                  ) : (
                    <>
                      <div className="progress-bar-box">
                        {questionAnswerSet.map((_, index) => (
                          <React.Fragment key={index}>
                            <div
                              className={`progress-step ${
                                index < step
                                  ? "completed"
                                  : index === step
                                    ? "active"
                                    : ""
                              }`}
                            >
                              {index < step ? "✔" : ""}
                            </div>
                            {index < questionAnswerSet.length - 1 && (
                              <div
                                className={`progress-line ${
                                  index < step
                                    ? "completed"
                                    : index === step
                                      ? "actives"
                                      : ""
                                }`}
                              ></div>
                            )}
                          </React.Fragment>
                        ))}
                      </div>

                      {questionAnswerSet.length > 0 && (
                        <>
                          <div className="question-title">
                            {questionAnswerSet[
                              step
                            ]?.questionText?.toUpperCase()}
                          </div>

                          <div className="options-grid">
                            {questionAnswerSet[step]?.options?.map((option) => (
                              <label
                                key={option?.optionId}
                                className="option-card"
                              >
                                <input
                                  type="radio"
                                  name={`question-${step}`}
                                  value={option?.optionId}
                                  checked={answers[step] === option?.optionId}
                                  onChange={() =>
                                    handleSelect(option?.optionId)
                                  }
                                />
                                <span className="custom-radio"></span>
                                {option?.optionName}
                              </label>
                            ))}
                          </div>
                        </>
                      )}

                      {error && (
                        <p
                          className="error-message"
                          style={{ color: "#f1d500" }}
                        >
                          {error}
                        </p>
                      )}
                      <button className="submit-btn" onClick={nextStep}>
                        {step < questionAnswerSet.length - 1
                          ? "Submit →"
                          : "Submit →"}
                      </button>

                      <div className="timer-box">
                        <h4>
                          Prediction Line opens at {startDateTime} and closes at{" "}
                          {endDateTime}.
                        </h4>
                        <br />
                        <h3>Hurry! Contest Ends in:</h3>

                        <div className="timer">
                          <div className="timesCounter">
                            <span>
                              {String(Math.floor(timeLeft / 3600)).padStart(
                                2,
                                "0",
                              )}
                            </span>
                            <p>HRS</p>
                          </div>
                          <span className="timesCounterSepration">:</span>
                          <div className="timesCounter">
                            <span>
                              {String(
                                Math.floor((timeLeft % 3600) / 60),
                              ).padStart(2, "0")}
                            </span>
                            <p>Mins</p>
                          </div>
                          <span className="timesCounterSepration">:</span>
                          <div className="timesCounter">
                            <span>
                              {String(Math.floor(timeLeft % 60)).padStart(
                                2,
                                "0",
                              )}
                            </span>
                            <p>Secs</p>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </>
              ) : (
                <>{timeLeft === 0 ? <PendingStart /> : <SorryUser />}</>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};
